import React, { useRef, useState } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import './index.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [token, setToken] = useState('');
    const turnstileRef = useRef(null);
    const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

    const API_BASE = process.env.REACT_APP_API_URL;

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!token) return alert('Please complete the check');

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password, cf_token: token })
        };

        try {
            const url = API_BASE + '/api/token/';
            const response = await fetch(url, requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            localStorage.setItem('access_token', data.access);
            localStorage.setItem('refresh_token', data.refresh);
            window.location.href = '/'; // You can pass the tokens to the parent component if needed
        } catch (error) {
            turnstileRef.current?.reset();
            setToken('');
            setError('Failed to login');
            console.error('There was a problem with the fetch operation:', error);
        }
    };

    return (
        <div className="login-container">
            <div className="login-shell">
                <div className="login-brand">
                    <p className="login-kicker">Jobsoft</p>
                    <h1>Operations login</h1>
                    <p className="login-copy">
                        Sign in to manage jobs, schedules, invoices, and field inventory.
                    </p>
                </div>
                <form onSubmit={handleLogin} className="login-form">
                    <div className="form-group">
                        <label className="label" htmlFor="login-username">Username</label>
                        <input
                            id="login-username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="input"
                            placeholder="Enter your username"
                            autoComplete="username"
                        />
                    </div>
                    <div className="form-group">
                        <label className="label" htmlFor="login-password">Password</label>
                        <input
                            id="login-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="input"
                            placeholder="Enter your password"
                            autoComplete="current-password"
                        />
                    </div>
                    <div className="form-group form-group--captcha">
                        <Turnstile
                            ref={turnstileRef}
                            siteKey={siteKey}
                            className="turnstile-widget"
                            style={{ display: 'block' }}
                            onSuccess={(value) => {
                                setToken(value);
                                setError('');
                            }}
                            onExpire={() => setToken('')}
                            onError={() => {
                                setToken('');
                                setError('The security check could not be displayed. Please refresh and try again.');
                            }}
                            onUnsupported={() => {
                                setToken('');
                                setError('This browser cannot display the security check.');
                            }}
                            options={{
                                action: 'turnstile-spin-v2',
                                appearance: 'always',
                                execution: 'render',
                                size: 'normal',
                            }}
                        />
                    </div>
                    {error && <p className="error">{error}</p>}
                    <button type="submit" className="button">Login</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
